/**
 * Экранирует значение для безопасного использования в CSV.
 * @param value - Любое значение (строка, число, boolean, null, undefined, объект).
 * @returns {string} - Санированное значение.
 */
export const sanitizeCsvValue = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '';
    }

    const str = typeof value === 'object' ? JSON.stringify(value) : String(value);

    // Защита от CSV Injection (Excel формулы)
    const escapedStr = str.replace(/^[=+\-@\t]/, "'$&");

    // Если есть запятые, кавычки или переносы строк — оборачиваем в кавычки
    if (/[,"\n\r]/.test(escapedStr)) {
        return `"${escapedStr.replace(/"/g, '""')}"`;
    }

    return escapedStr;
};
